import { defineStore } from 'pinia'

export interface Group {
  title: string
  items: {
    name: string
    url: string
  }[]
}
export const useDocumentStore = defineStore('document', () => {
  const open = ref(false)
  const url = ref('')
  const name = ref('')
  const documentLink = useDocumentLink()
  function openDocument(newUrl: string, newName: string) {
    url.value = documentLink(newUrl)
    name.value = newName
    open.value = true
  }
  function closeDocument() {
    open.value = false
  }
  watch(open, (newValue) => {
    if (!newValue) {
      url.value = ''
      name.value = ''
    }
  })

  return {
    open,
    url,
    name,
    openDocument,
    closeDocument,
  }
})
